var React = require('react');

function HeartInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 28.4667L14.0667 26.7067C7.20001 20.48 2.66667 16.3733 2.66667 11.3333C2.66667 7.22667 5.89334 4 10 4C12.32 4 14.5467 5.08 16 6.78667C17.4533 5.08 19.68 4 22 4C26.1067 4 29.3333 7.22667 29.3333 11.3333C29.3333 16.3733 24.8 20.48 17.9333 26.72L16 28.4667Z","fill":"#323232"}));
}

HeartInline.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = HeartInline;

HeartInline.default = HeartInline;
